
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { serviceFactory } from '@/services';
import { CareSpecialistService, type CareSpecialist } from '@/services/features/CareSpecialistService.ts';

export const useCareSpecialists = () => {
  const { hasuraToken } = useAuth();

  // Get service instance
  const careSpecialistService = serviceFactory.getService(CareSpecialistService);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['careSpecialists'],
    queryFn: async (): Promise<CareSpecialist[]> => {
      if (!hasuraToken) {
        return [];
      }

      try {
        const response = await careSpecialistService.fetchCareSpecialists();

        if (!response.success) {
          return [];
        }

        const specialists = response.data?.pep_vw_care_specialist_list || [];

        return specialists;
      } catch (error) {
        return [];
      }
    },
    enabled: !!hasuraToken,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    careSpecialists: data || [],
    isLoading,
    error,
    refetch,
  };
};
